import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import PropTypes from "prop-types";
import ManagePlayerLists from "../../components/players/ManagePlayerLists";
import { RouteConstants } from "../../constants/RouteConstants";

class PlayerListContainer extends Component {
  componentDidMount() {
    const { trackingHelper } = this.props.rootStore;
    trackingHelper.trackPageView(RouteConstants.PLAYER_LISTS.title);
  }

  render() {
    return (
      <div className="container-fluid">
        <div className="col-12 p-0 mb-4">
          <ManagePlayerLists />
        </div>
      </div>
    );
  }
}

PlayerListContainer.propTypes = {
  rootStore: PropTypes.object.isRequired
};

export default inject("rootStore")(observer(PlayerListContainer));
